import model, { ModelWithState } from '@/utils/model'
import { produce } from 'immer'

export interface ModelState {
  collapsed: boolean
  activeKey: ''
  closeSymbol?: symbol
  isAiTrain: number
}

const UserModel: ModelWithState<ModelState> = model.extend({
  namespace: 'guide',
  state: {
    collapsed: true,
    activeKey: '',
    closeSymbol: undefined,
    isAiTrain: 1,
  },
  effects: {},

  reducers: {
    close(state: ModelState) {
      return {
        ...state,
        closeSymbol: Symbol(Date.now()),
      }
    },
    setState: produce((state, action) => ({
        ...state,
        ...action.payload,
      })),
  },
  subscriptions: {},
})

export default UserModel
